import React, { useContext } from "react";
import styles from "./LetUsComponent.module.css";
import { ThemeContext } from "../../App";

export default function LetUsComponent() {

  const { theme } = useContext(ThemeContext);

  return (
    <div id={styles[theme]} className={styles.letUsBlock}>
      <h3 className="text-smBtwPages md:text-mdBtwPages lg:text-lgBtwPages w-4/5">
        Trust us.
        <br />
        Technology is <strong>our vocation,</strong> solutions are{" "}
        <strong>our specialty.</strong>
      </h3>
    </div>
  );
}
